// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"css_wrapper__oxMov","wrapper__label":"css_wrapper__label__36OG4","autocomplete":"css_autocomplete__2NY6j","autocomplete__input":"css_autocomplete__input__1qVm0"};